module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('base-layout', [_c('ul', {
    staticClass: "nav navbar-nav navbar-left",
    attrs: {
      "slot": "toolbar_buttons"
    },
    slot: "toolbar_buttons"
  }, [_c('li', [_c('date-range-picker', {
    attrs: {
      "dateFields": _vm.dateFields,
      "datesRange": _vm.datesRange
    },
    on: {
      "dates-range-updated": _vm.updatedDates
    }
  })], 1), _vm._v(" "), (_vm.isAdmin) ? _c('li', [_c('button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.bottom",
      value: ('Refresh Dashboard'),
      expression: "'Refresh Dashboard'",
      modifiers: {
        "bottom": true
      }
    }],
    staticClass: "btn btn-icon",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.refreshDashboard
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-refresh"
  })])]) : _vm._e(), _vm._v(" "), _c('li', [_c('button', {
    staticClass: "btn btn-icon",
    class: {
      filtered: _vm.showLeadsTable
    },
    on: {
      "click": _vm.toggleLeadsTable
    }
  }, [_c('i', {
    staticClass: "fa fa-table"
  })])]), _vm._v(" "), (_vm.isAdmin) ? _c('li', [_c('button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.bottom",
      value: ('Add Component'),
      expression: "'Add Component'",
      modifiers: {
        "bottom": true
      }
    }],
    staticClass: "btn btn-icon",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showComponentModal()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-plus"
  })])]) : _vm._e(), _vm._v(" "), (_vm.isAdmin) ? _c('li', [_c('button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.bottom",
      value: ('Edit Dashboard'),
      expression: "'Edit Dashboard'",
      modifiers: {
        "bottom": true
      }
    }],
    staticClass: "btn btn-icon",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.isDashboardModalVisible = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-lg fa-pencil"
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 main with-leads-table",
    class: {
      'with-leads-table-active': _vm.showLeadsTable
    },
    attrs: {
      "slot": "main",
      "id": "dashboard-canvas"
    },
    slot: "main"
  }, [_c('div', {
    staticClass: "row ls-charts"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "col-xs-12 spinner-container"
  }, [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin fa-3x fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.currentPivots.length) ? _c('div', {
    staticClass: "pivots-wrapper"
  }, _vm._l((_vm.currentPivots), function(pivot, pivotIx) {
    return _c('span', {
      staticClass: "pivot label"
    }, [(pivot) ? [_vm._v("\n                            " + _vm._s(pivot.field.name) + ":\n                            "), _c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (pivot.is_not),
        expression: "pivot.is_not"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(pivot.is_not) ? _vm._i(pivot.is_not, null) > -1 : (pivot.is_not)
      },
      on: {
        "change": [function($event) {
          var $$a = pivot.is_not,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(pivot, "is_not", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(pivot, "is_not", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(pivot, "is_not", $$c)
          }
        }, function($event) {
          return _vm.updatePivotValue(pivot, pivotIx)
        }]
      }
    }), _vm._v(" is not")]), _vm._v(" \n                            "), (pivot.isLoading) ? _c('span', [_c('i', {
      staticClass: "fa fa-circle-o-notch fa-spin"
    }), _vm._v("Loading ...")]) : _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (pivot.value),
        expression: "pivot.value"
      }],
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(pivot, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.updatePivotValue(pivot, pivotIx)
        }]
      }
    }, [_c('option', {
      attrs: {
        "disabled": !pivot.options
      },
      domProps: {
        "value": null
      }
    }, [_c('span', [_c('i', [_vm._v("- none -")])])]), _vm._v(" "), _vm._l((pivot.options), function(v) {
      return _c('option', {
        domProps: {
          "value": v
        }
      }, [_vm._v(_vm._s(v))])
    })], 2)] : _vm._e()], 2)
  }), 0) : _vm._e(), _vm._v(" "), (_vm.dashboard.name) ? _c('h1', [_vm._v(_vm._s(_vm.dashboard.name))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 ls-charts-wrapper"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [(_vm.components.length) ? _c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('grid-layout', {
    attrs: {
      "layout": _vm.components,
      "col-num": 6,
      "row-height": 60,
      "is-draggable": _vm.isAdmin,
      "is-resizable": _vm.isAdmin,
      "vertical-compact": true,
      "margin": [10, 10],
      "use-css-transforms": false,
      "responsive": false,
      "auto-size": true
    }
  }, _vm._l((_vm.components), function(item, index) {
    return _c('grid-item', {
      key: item.i,
      ref: "components",
      refInFor: true,
      attrs: {
        "x": item.x,
        "y": item.y,
        "w": item.w,
        "h": item.h,
        "i": item.i,
        "minW": _vm.minW(item),
        "maxW": _vm.maxW(item),
        "minH": _vm.minH(item),
        "maxH": _vm.maxH(item),
        "drag-allow-from": '.panel-header h3'
      },
      on: {
        "moved": _vm.layoutUpdated,
        "resized": _vm.layoutUpdated
      }
    }, [_c('component-box', {
      attrs: {
        "width": item.w,
        "height": item.h,
        "component": item,
        "dashboardRules": _vm.computedFilters,
        "index": index,
        "datesRange": _vm.datesRange
      },
      on: {
        "deleteComponent": _vm.deleteComponent,
        "cloneComponent": _vm.cloneComponentInDashboard,
        "showEditModal": _vm.showComponentModal
      }
    })], 1)
  }), 1)], 1)]) : _c('div', {
    staticClass: "col-xs-offset-3 col-xs-6"
  }, [_c('div', {
    staticClass: "well well-lg empty-msg"
  }, [_vm._v("\n\t\t                This dashboard is empty, start by "), _c('a', {
    staticClass: "text-primary",
    on: {
      "click": function($event) {
        return _vm.showComponentModal()
      }
    }
  }, [_vm._v("adding")]), _vm._v(" the first chart.\n                            ")])])])])]), _vm._v(" "), (_vm.showLeadsTable) ? _c('div', {
    staticClass: "row ls-leads-table"
  }, [_c('div', {
    staticClass: "col-xs-12 leads-queue-wrapper"
  }, [_c('div', {
    staticClass: "box panel leads-queue full-height"
  }, [_c('div', {
    staticClass: "panel-content chart-wrapper full-height"
  }, [_c('div', {
    staticClass: "endless-table-container full-height"
  }, [_c('endless-table', {
    attrs: {
      "dashboard-id": _vm.dashboard.id,
      "isAdmin": _vm.isAdmin,
      "rules": _vm.computedFilters,
      "datesRange": _vm.datesRange,
      "pickedColumns": _vm.pickedColumns,
      "showLeadsTable": _vm.showLeadsTable
    },
    on: {
      "showColumnPicker": function($event) {
        return _vm.openColumnPicker()
      },
      "leadsDownload": function($event) {
        return _vm.download()
      },
      "do-text-search": _vm.doTextSearch
    }
  })], 1)])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modals"
    },
    slot: "modals"
  }, [(_vm.isDashboardModalVisible && _vm.isAdmin) ? _c('dashboard-modal', {
    attrs: {
      "dashboardId": _vm.dashboardId
    },
    on: {
      "save": function($event) {
        return _vm.fetchDashboard(true)
      },
      "clone": _vm.cloneDashboard,
      "close": function($event) {
        _vm.isDashboardModalVisible = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isModalVisible && _vm.isAdmin) ? _c('component-modal', {
    attrs: {
      "dashboardRules": _vm.computedFilters,
      "component": _vm.editedComponent,
      "datesRange": _vm.datesRange
    },
    on: {
      "close": _vm.closeComponentModal,
      "showModal": _vm.showComponentModal
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showColumnPicker && _vm.isAdmin) ? _c('columns-picker-modal', {
    attrs: {
      "available-columns": _vm.availableColumns
    },
    on: {
      "close": function($event) {
        _vm.showColumnPicker = false
      },
      "setColumns": _vm.setColumns
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0bc3e1fc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/private/Dashboard.vue
// module id = 606
// module chunks = 0